<template>
  <div class="column padding-left20 text-size text-color bold">
    <!-- Title -->
    <div :class="$style.criteriaTitleField">
      <span v-html="highlightedTitle"></span>

      <b-tag v-if="showCustomTag" type="is-primary" class="margin-left12">
        <p class="is-text-info">CUSTOM</p>
      </b-tag>
    </div>

    <!-- Criteria Options -->
    <div :class="$style.criteriaOptions">
      <template v-if="criteria.type === 'BOOLEAN'">
        <div
          :class="$style.criteriaBooleanOptions"
          v-for="(booleanOption, booleanIndex) in getCriteriaOptions(criteria)"
          :key="booleanIndex"
        >
          <b-radio disabled size="is-small" native-value="booleanOption">
            <span :class="$style.optionText">
              {{ booleanOption }}
            </span>
          </b-radio>
        </div>
      </template>

      <template v-if="criteria.type === 'RANGE'">
        <div :class="$style.criteriaRangeOptions">
          Min:
          {{ getCriteriaOptions(criteria)[0] }}
        </div>
        <div :class="$style.criteriaRangeOptions">
          Max:
          {{ getCriteriaOptions(criteria)[1] }}
        </div>
        <div :class="$style.criteriaRangeOptions">
          N/A:
          {{ getCriteriaOptions(criteria)[2] }}
        </div>
      </template>

      <template v-if="criteria.type === 'CHECKBOXES'">
        <div
          :class="$style.criteriaCheckBoxOptions"
          v-for="(
            checkboxesOption, checkboxesOptionIndex
          ) in getCriteriaOptions(criteria)"
          :key="checkboxesOptionIndex"
        >
          <b-checkbox disabled size="is-small" type="is-info">
            <span :class="$style.optionText">
              {{ checkboxesOption }}
            </span>
          </b-checkbox>
        </div>
      </template>
    </div>

    <!-- Criteria tags -->
    <template v-for="plainTag in criteria.tags.plain">
      <span :class="$style.tag">{{ plainTag }}</span>
    </template>
    <template v-for="meshTag in criteria.tags.mesh">
      <span :class="$style.tag">{{ meshTag }}</span>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CplusCriteria,
  JBICriterion,
  JBICriterionTypeBoolean,
  JBICriterionTypeCheckboxes,
  JBICriterionTypeRange,
} from '@/store/modules/projects/types/projects.types';
import { CRITERION_TYPE } from '@/jbi-shared/types/criterions.types';
import { highlightText } from '@/utils/highlight.util';

@Component({})
export default class CriteriaDetailsTemplate extends Vue {
  @Prop() criteria!: CplusCriteria | JBICriterion;
  @Prop({ type: String, default: '' }) activeSearchTerm!: string;

  get highlightedTitle(): string {
    return highlightText(this.criteria.title, this.activeSearchTerm);
  }

  get showCustomTag() {
    const criteria: CplusCriteria = this.criteria as CplusCriteria;
    if (
      (criteria.document !== undefined && criteria.document.id === '') ||
      (criteria.isCustom && criteria.isCustom === true) ||
      (criteria.isChanged && criteria.isChanged === true)
    ) {
      return true;
    }

    return false;
  }

  getCriteriaOptions(criteria: CplusCriteria | JBICriterion): string[] {
    let options: string[] = [];
    switch (criteria.type) {
      case CRITERION_TYPE.BOOLEAN:
        options = (criteria as JBICriterionTypeBoolean).booleanOptions;
        break;
      case CRITERION_TYPE.RANGE:
        options = (criteria as JBICriterionTypeRange).range;
        break;
      case CRITERION_TYPE.CHECKBOXES:
        options = (criteria as JBICriterionTypeCheckboxes).checkboxesOptions;
        break;
      default:
        break;
    }

    return options;
  }
}
</script>

<style lang="scss" module>
.criteriaTitleField {
  font-weight: 600;
}

.criteriaOptions {
  padding: 8px 0 12px 0;
}

.criteriaBooleanOptions,
.criteriaCheckBoxOptions,
.criteriaRangeOptions {
  padding-top: 5px;
}

.optionText {
  color: #444f51 !important;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  text-wrap: nowrap;
}

.tag {
  background: none;
  color: #9a9a9a;
  font-size: 12px;
  padding-right: 15px;
  text-transform: capitalize;
  line-height: 14px;
  font-weight: 400;
}

:global(.highlight) {
  background-color: #c2e3ff;
  font-weight: 600;
}
</style>
